const checkItems = [
  "Persistent leaks despite previous repairs",
  "Water intrusion under hydrostatic pressure",
  "Escalating maintenance costs with no resolution",
  "Residents or tenants complaining about moisture",
  "Upcoming milestone inspection or structural review",
];

interface UrgencySectionProps {
  onInspectionClick: () => void;
  onAssessmentClick: () => void;
}

export default function UrgencySection({ onInspectionClick, onAssessmentClick }: UrgencySectionProps) {
  return (
    <section id="urgency" className="bg-[#050a1f] py-20 md:py-28 relative overflow-hidden">
      {/* Subtle grid bg */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "linear-gradient(#0055ff 1px, transparent 1px), linear-gradient(90deg, #0055ff 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      ></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        {/* Label */}
        <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-700/40 text-red-400 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-alarm-warning-fill"></i>
          </span>
          Act Before It Escalates
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-10 leading-tight">
          Is Your Building Experiencing{" "}
          <span className="text-[#4a7fa5]">Any of These?</span>
        </h2>

        {/* Checklist */}
        <ul className="flex flex-col gap-4 mb-10 text-left max-w-xl mx-auto">
          {checkItems.map((item) => (
            <li key={item} className="flex items-start gap-4">
              <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 rounded bg-[#1a3a5c]/30 border border-[#4a7fa5]/40">
                <i className="ri-check-line text-[#4a7fa5] text-sm"></i>
              </span>
              <span className="text-gray-200 text-base font-medium">{item}</span>
            </li>
          ))}
        </ul>

        {/* Warning line */}
        <p className="text-red-400 font-bold text-base md:text-lg mb-10 italic">
          &ldquo;Every day without treatment is a day the concrete deteriorates further.&rdquo;
        </p>

        {/* Dual CTAs */}
        <div className="flex flex-col gap-3 justify-center w-full max-w-md mx-auto sm:max-w-none sm:flex-row sm:gap-4">
          <button
            onClick={onInspectionClick}
            className="bg-[#1a3a5c] hover:bg-[#0f2a45] text-white font-bold px-6 py-4 rounded-md transition-all text-sm w-full sm:w-auto shadow-lg shadow-[#1a3a5c]/40"
          >
            Schedule a Free Engineering Inspection
          </button>
          <button
            onClick={onAssessmentClick}
            className="border-2 border-white/30 hover:border-white text-white font-bold px-6 py-4 rounded-md transition-all text-sm w-full sm:w-auto bg-white/5 hover:bg-white/10"
          >
            Request a Professional Water Intrusion Assessment
          </button>
        </div>
      </div>
    </section>
  );
}
